module.exports = __webpack_public_path__ + "static/media/chart-line.7402d288.svg";